import FetchPostDataWithAuthNEW from "../services/FetchPostDataWithAuthNEW";

export default async function FechPostAddPromotionConnection(club, body) {
  var url = "/reservation/create_promotion_connection/" + club;

  var data = await FetchPostDataWithAuthNEW(url, body);

  return data;
}
